import { CampaignActionTypes } from 'modules/campaign/actionTypes';
import { CommonMapper } from 'mappers/common';
import { CampaignMapper } from 'mappers/campaign';

const getCampaignDetails = campaign_url_slug => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: CampaignActionTypes.CAMPAIGNBANNER.FETCH,
    payload: {},
    test: api
      .post(`getCampaigns.json`, { campaign_url_slug })
      .then(res => {
        const response = res.data.data || {};
        const campaign_data = response.campaign || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: CampaignActionTypes.CAMPAIGNBANNER.SUCCESS,
          payload: CampaignMapper.mapCampaignDetails(
            campaign_data,
            mediaPath,
            campaign_url_slug
          ),
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: CampaignActionTypes.CAMPAIGNBANNER.FAILURE,
          error,
        });
      }),
  });
};

export const CampaignAction = {
  getCampaignDetails,
};
